var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-scoll"},[_c('div',{staticClass:"teacher-area"},[_c('div',{staticClass:"teacher"},[_c('div',{staticClass:"scroll"},[_c('timetable',{attrs:{"id":_vm.group_id}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }